import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BellRing } from "lucide-react";

export function DuReminderSettings() {
  const [s, setS] = useState(null);
  const [templates, setTemplates] = useState([]);
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
    api.get("/email-templates").then((r) => setTemplates(r.data.filter((t) => !t.system))).catch(() => {});
  }, []);
  const save = async (patch) => {
    const next = { ...s, ...patch };
    if (next.du_reminder_enabled && !next.du_reminder_template_id) { toast.error("Bitte zuerst eine Vorlage wählen"); return; }
    try { await api.put("/settings", patch); setS(next); toast.success("Erinnerung gespeichert"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (!s) return null;
  return (
    <div className="flex items-center gap-3 flex-wrap bg-white border border-slate-200 rounded-xl px-4 py-3 mb-4 shadow-sm" data-testid="du-reminder-settings">
      <BellRing size={16} className="text-slate-500" />
      <span className="text-sm font-medium text-slate-800">Automatische Erinnerung</span>
      <Switch checked={!!s.du_reminder_enabled} onCheckedChange={(v) => save({ du_reminder_enabled: v })} data-testid="du-reminder-toggle" />
      <Input type="number" min={1} max={60} value={s.du_reminder_days ?? 7} onChange={(e) => setS({ ...s, du_reminder_days: e.target.value })}
        onBlur={() => save({ du_reminder_days: Number(s.du_reminder_days) || 7 })} className="w-16 h-8" data-testid="du-reminder-days" />
      <span className="text-sm text-slate-600">Tage vor Redaktionsschluss mit Vorlage</span>
      <Select value={s.du_reminder_template_id || ""} onValueChange={(v) => save({ du_reminder_template_id: v })}>
        <SelectTrigger className="w-72 h-8" data-testid="du-reminder-template"><SelectValue placeholder="Vorlage wählen" /></SelectTrigger>
        <SelectContent>{templates.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
      </Select>
      <span className="text-xs text-slate-400 basis-full">Geht einmal pro Ausgabe an alle aktiven Partner mit Freianzeige, deren DU noch nicht geliefert ist (tägliche Prüfung um 8 Uhr).</span>
    </div>
  );
}
